"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./programs.scss");
var member_view_1 = require("../../components/member/member-view");
var Members = function (props) {
    var _a = props.match.params, orgId = _a.orgId, memberId = _a.memberId;
    return (React.createElement("div", { id: "member-view", className: "container hub-full-width" },
        React.createElement("div", { className: "page-content u-xs-padXl u-flexExpandSides" },
            React.createElement("div", { className: "page-content-body" },
                React.createElement(member_view_1.default, { orgId: +orgId, memberId: +memberId })))));
};
exports.default = Members;
//# sourceMappingURL=member-view.js.map